export default {
  title: "Divider",
  type: "rh/components/content/divider",
  isContainer: false,
  config: {
    emptyLabel: "Divider",
    isEmpty: () => false
  }
};
